import { Syringe, Check } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { uuid } from "@/lib/format";
import { vaccineDue, today } from "@/lib/clinic";

export default function VaccineSchedule({ patient, records }) {
  const { t, dispatch, can } = useApp();
  const due = vaccineDue(patient.birth_date);
  if (!due.length) return <p className="text-sm text-muted-foreground" data-testid="vaccine-no-birth">{t("vaccine_need_birth")}</p>;
  const done = (k) => records.find((r) => r.kind === "vaccine" && r.vaccine_key === k);
  const give = (v) => {
    if (dispatch("record.upsert", { id: uuid(), patient_id: patient.id, patient_name: patient.name, kind: "vaccine", vaccine_key: v.k, name: t(`vac_${v.k}`), result: t("given"), date: today(), next_date: "", note: "" })) toast.success(t("saved"));
  };
  return (
    <div className="rounded border border-[#CCCCCC] bg-white overflow-hidden" data-testid="vaccine-schedule">
      <div className="px-3 py-2 bg-[#E8E8E8] text-xs font-bold flex items-center gap-2"><Syringe className="w-4 h-4" />{t("vaccine_schedule")}</div>
      <div className="divide-y divide-[#EEE]">
        {due.map((v) => {
          const d = done(v.k);
          const late = !d && v.due < today();
          return (
            <div key={v.k} className="flex items-center gap-3 px-3 py-1.5 text-sm" data-testid={`vac-row-${v.k}`}>
              <span className={`w-2.5 h-2.5 rounded-full ${d ? "bg-[#1F9D55]" : late ? "bg-[#C7353B]" : "bg-[#CCCCCC]"}`} />
              <span className="flex-1">{t(`vac_${v.k}`)} <span className="text-xs text-[#666]">({v.m} {t("months_short")})</span></span>
              <span dir="ltr" className={`text-xs ${late ? "text-[#C7353B] font-bold" : "text-[#666]"}`}>{d ? d.date : v.due}</span>
              {d ? <Check className="w-4 h-4 text-[#1F9D55]" /> : can("medical") && <button type="button" onClick={() => give(v)} className="h-7 px-2 rounded bg-[#2B79C2] text-white text-xs font-bold" data-testid={`vac-give-${v.k}`}>{t("mark_given")}</button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
